import { listFormatter } from 'components/molecules/TableFormatters/listFormatter'
import { DataTables } from 'components/organisms/DataTable/index'
import React from 'react'

const CompanyDetail = ({ row = {}, isMobileView = false }) => {
  const config = [
    {
      dataField: 'department',
      text: 'Departments',
      headerAttrs: { width: isMobileView ? 150 : 200 },
      formatter: listFormatter,
      formatExtraData: {
        field: 'department',
      },
      sort: true
    },
    {
      dataField: 'contractor',
      text: 'Contractors',
      headerAttrs: { width: isMobileView ? 150 : 200 },
      formatter: listFormatter,
      formatExtraData: {
        field: 'contractor',
      },
      sort: true
    },
    {
      dataField: 'location',
      text: 'Pits',
      headerAttrs: { width: isMobileView ? 150 : 200 },
      formatter: listFormatter,
      formatExtraData: {
        field: 'location',
      },
      sort: true
    },
  ]

  const getMergedData = (length) => {
    const tempArray = new Array(length).fill()
    const mergedArray = tempArray.map((d,i) => {
      return {
        id: i,
        contractor: row.contractors[i] ? row.contractors[i].name : '',
        department: row.departments[i] ? row.departments[i].nameDisplay : '',
        location: row.locations[i] ? row.locations[i].name : '',
      }
    })
    return mergedArray
  }

  const maxLength = Math.max(row.contractors.length, row.departments.length, row.locations.length)
  const mergedData = getMergedData(maxLength)

  return (
    <div>
      <DataTables
        key={row.id}
        containerClassName="col-12 px-0"
        minWidth={'700px'}
        noHeadings
        rightSlotAlt={true}
        defaultSize={100}
        dataList={mergedData || []}
        columnConfig={config}
      />
    </div>
  )
}

export default CompanyDetail
